import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import Chip from '@material-ui/core/Chip';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import CancelIcon from '@material-ui/icons/Clear';
import { deepValue } from 'helpers/utils';
import { makeStyles } from '@material-ui/core/styles';
import { cancelUserActionSubscriptionByActionId } from './userActionSubscriptionsActions';

const useRowStyles = makeStyles({
  tableRow: {
    '& > *': {
      border: 'unset',
    },
  },
  borderColor: {
    border: '1px solid rgba(224, 224, 224, 1)',
  },
  cancelledChip: {
    marginLeft: 24,
  }
});

function Row(props) {
  const { row, columns, initialOpen, onCancel } = props;
  const [open, setOpen] = useState(initialOpen);
  const classes = useRowStyles();
  const isCancelled = row.some(item => item.cancelled);

  const handleCancel = (id) => {
    if (onCancel) {
      onCancel(id);
    }
  };

  return (
    <React.Fragment>
      <TableRow className={classes.tableRow}>
        <TableCell>
          <IconButton aria-label="expandir registro" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          { row[0].action_subscription.description }
          {
            isCancelled && (
              <Chip
                variant="outlined"
                size="small"
                className={classes.cancelledChip}
                icon={<CancelIcon />}
                label="Cancelada"
                color="secondary"
              />
            )
          }
        </TableCell>
        <TableCell align="right">
          <Tooltip title="Cancelar assinatura">
            <IconButton
              aria-label="cancelar pagamento"
              size="small"
              disabled={isCancelled}
              onClick={() => handleCancel(row[0].actionId)}
            >
              <CancelIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Cobranças
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    {columns.map(column => (
                      <TableCell>{ column['title']} </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.map((historyRow) => (
                    <TableRow className={classes.borderColor} key={`row-${historyRow.actionid}`}>
                      {columns.map(column => (
                        <TableCell>{ deepValue(historyRow, column['field'])} </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const UserActionSubscriptionsTable = function ({
  // history,
  columns,
  data,
  cancelUserActionSubscriptionByActionId,
}) {
  const dataKeys = Object.keys(data);
  return (
    <TableContainer component={Paper}>
      <Table aria-label="Assinaturas">
        <TableBody>
          {dataKeys.map((key) => (
            <Row
              key={key}
              row={data[key]}
              columns={columns}
              actionid={key}
              initialOpen={dataKeys?.length === 1}
              onCancel={(id) => cancelUserActionSubscriptionByActionId(id)}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    general: state.general,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    cancelUserActionSubscriptionByActionId,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(UserActionSubscriptionsTable);
